/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_DealsInputs */

const cs_dashboard_kpi_deals = /** @type {(inputs: Dashboard_Kpi_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní obchody`)
};

const en_dashboard_kpi_deals = /** @type {(inputs: Dashboard_Kpi_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active deals`)
};

/**
* | output |
* | --- |
* | "Active deals" |
*
* @param {Dashboard_Kpi_DealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_deals = /** @type {((inputs?: Dashboard_Kpi_DealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_DealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_deals(inputs)
	return cs_dashboard_kpi_deals(inputs)
});